import Swal from "sweetalert2";
import colors from "../constants/colors";
import es from "../lang/es";

const alertMessages = {
    close: () => {
        Swal.close();
    },

    error: title => {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            background: colors.lightRed
        }).fire({
            icon: 'error',
            title
        })
    },

    confirm: data => {
        Swal.fire({
            title: data.title,
            text: data.text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: data.confirmColor,
            cancelButtonText: es.CANCEL,
            confirmButtonText: data.confirmText
        }).then(async (result) => {
            //Si acepta, procedo a eliminar
            if(result.value){
                //Ejecuto
                data.callback()
            }
        });
    },

    waiting: title => {
        Swal.fire({
            title,
            text: es.PLEASE_WAIT,
            didOpen: () => {
                Swal.showLoading()
            },
            allowOutsideClick: false
        });
    },

    success: title => {
        Swal.mixin({
            toast: true,
            position: 'top-start',
            showConfirmButton: false,
            timer: 5000,
            background: colors.lightGreen
        }).fire({
            icon: 'success',
            title
        })
    },

    info: title => {
        Swal.mixin({
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 5000,
            background: colors.lightYellow
        }).fire({
            icon: 'info',
            title
        })
    }
}

export default alertMessages;